var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNavigationUpCircle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.00195 5.00061L8.00195 11.0006",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.50195 7.50061L8.00195 5.00061L10.502 7.50061",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.00195 1.00055C6.14544 1.00055 4.36496 1.73805 3.0522 3.0508C1.73945 4.36356 1.00195 6.14403 1.00195 8.00055C1.00195 9.85706 1.73945 11.6375 3.0522 12.9503C4.36496 14.2631 6.14544 15.0005 8.00195 15.0005C9.85847 15.0005 11.6389 14.2631 12.9517 12.9503C14.2645 11.6375 15.002 9.85706 15.002 8.00055C15.002 6.14403 14.2645 4.36356 12.9517 3.0508C11.6389 1.73805 9.85847 1.00055 8.00195 1.00055V1.00055Z",
    stroke: "black",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white",
    transform: "translate(16) rotate(90)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavigationUpCircle);
export default __webpack_public_path__ + "static/media/NavigationUpCircle.64a8c3d63cdef6bc02cfc7852bc39aa8.svg";
export { ForwardRef as ReactComponent };